/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-09-24 09:46:24
 * @LastEditors: susj
 * @LastEditTime: 2022-10-08 10:36:38
 */
import request from '@/utils/request';

const requestInstance = request();

// 文件上传请求头
export function uploadFileHeader() {
  return {
    sysCode: 'schemeshow',
  };
}

// img 上传
export function imgUpload() {
  return `${process.env.VUE_APP_API_BASE_URL}/api/C/schemeshow/file/importImage`;
}

export function submitWenjuan(params) {
  return requestInstance.post('/api/sdyy/sdquestionnaire/submit', params);
}

// ppt 上传
export function pptUpload() {
  return `${process.env.VUE_APP_API_BASE_URL}/api/C/schemeshow/file/importOrganTemplate`;
}

// // 导出ppt
// export function exportPpt(params) {
//   return requestInstance.post('/api/C/schemeshow/file/exportPpt', params, {
//     responseType: 'blob',
//   });
// }

// // 导出pdf
// export function exportPdf(params) {
//   return requestInstance.post('/api/C/schemeshow/file/exportPdf', params, {
//     responseType: 'blob',
//   });
// }
// 导出ppt
export function exportPpt(params) {
  return requestInstance.post('/api/C/schemeshow/file/exportPpt2', params);
}
// 导出pdf
export function exportPdf(params) {
  return requestInstance.post('/api/C/schemeshow/file/exportPdf2', params);
}

// 更新ppt
export function pptWrapUpdate(params) {
  return requestInstance.post('/api/schemeshow/pptWrap/update', params);
}

// 保存整个pptInfo数据落库
export function pptWrapSaveInfo(params) {
  return requestInstance.post('/api/schemeshow/pptWrap/saveInfo', params);
}

// 通过id获取某个方案秀
export function getOnePptWrap(params) {
  return requestInstance.post('/api/schemeshow/pptWrap/get', params);
}

// 通过方案信息和对应的方案秀列表
export function getSchemeInfoAndList(params) {
  return requestInstance.post('/api/schemeshow/pptWrap/schemeShowListByUserId', params);
}

// 方案秀模板列表
export function getTemplateList(params) {
  return requestInstance.post('/api/schemeshow/pptWrap/userTemplateList', params);
}

// 创建方案秀
export function createScheme(params) {
  return requestInstance.post('/api/schemeshow/pptWrap/createAsync', params);
}
// 删除方案秀
export function deleteScheme(params) {
  return requestInstance.post('/api/schemeshow/pptWrap/delete', params);
}

// 保存方案
export function saveScheme(params) {
  return requestInstance.post('/api/schemeshow/pptWrap/savePptAsync', params);
}

// 查看分享ppt截图预览
export function getPptBrief(params) {
  return requestInstance.post('/api/schemeshow/pptWrap/getPptBrief', params);
}
// 查看分享ppt截图预览
export function getPptShare(params) {
  return requestInstance.get(`${process.env.VUE_APP_API_SHARE_URL}/schemeShow/getPptInfo/${params.id}`);
}

// 收藏
export function collectTemplate(params) {
  return requestInstance.post('/api/schemeshow/pptWrap/collectTemplate', params);
}

// 取消收藏
export function unCollectTemplate(params) {
  return requestInstance.post('/api/schemeshow/pptWrap/unCollectTemplate', params);
}

// 效果图列表
export function getEffectPic(params) {
  return requestInstance.post('/api/schemeshow/schemeWrap/getEffectPic', params);
}

// 获取账号方案秀权限码
export function getOperation(params) {
  return requestInstance.post('/api/schemeshow/userOperation/getOperation', params);
}

// 判断是否有该权限
export function hasOperation(params) {
  return requestInstance.post('/api/schemeshow/userOperation/hasOperation', params);
}

// 生成全景链接二维码
export function getPanoramaQrCode(params) {
  return requestInstance.post('/api/schemeshow/pptWrap/generatePanoramaQrCode', params);
}

// 获取文案的分类
export function getSentenceCategoryList(params) {
  return requestInstance.post('/api/schemeshow/sentenceCategory/getChildren', { ...params });
}

// 获取二级的分类下的文案
export function getSentenceList(params) {
  return requestInstance.post('/api/schemeshow/sentence/list', { ...params });
}
// 获取文案类型及其子类型的文案列表
export function getSentenceListWithChild(params) {
  return requestInstance.post('/api/schemeshow/sentence/listWithChild', { ...params });
}
